import { useMemo, useState } from "react";
import { ChevronDown, X } from "lucide-react";

export default function MultiSelect({ label, options, values, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const shown = useMemo(() => {
    const s = q.toLowerCase();
    return options.filter((o) => !s || o.label.toLowerCase().includes(s) || String(o.value).toLowerCase().includes(s)).slice(0, 200);
  }, [options, q]);

  const toggle = (v) => onChange(values.includes(v) ? values.filter((x) => x !== v) : [...values, v]);

  return (
    <div className="relative">
      <button onClick={() => setOpen((o) => !o)} data-testid={testid}
        className="flex items-center gap-1.5 bg-white border border-slate-300 rounded-md px-3 py-1.5 text-sm text-slate-700 hover:border-slate-400">
        {label}: {values.length ? <span className="font-semibold text-[#B01E24]">{values.length} selected</span> : "All"}
        <ChevronDown size={13} className="text-slate-400" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute z-40 mt-1 w-72 bg-white border border-slate-200 rounded-lg shadow-xl p-2" data-testid={`${testid}-panel`}>
            <div className="flex items-center gap-1.5 mb-1.5">
              <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…"
                className="flex-1 border border-slate-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:border-[#B01E24]/50" />
              {values.length > 0 && (
                <button onClick={() => onChange([])} className="text-[11px] text-slate-500 hover:text-[#B01E24] flex items-center gap-0.5">
                  <X size={11} /> Clear
                </button>
              )}
            </div>
            <div className="max-h-60 overflow-auto thin-scroll">
              {shown.map((o) => (
                <label key={o.value} className="flex items-center gap-2 px-1.5 py-1 rounded hover:bg-slate-50 cursor-pointer text-[12.5px]">
                  <input type="checkbox" checked={values.includes(o.value)} onChange={() => toggle(o.value)} className="accent-[#B01E24]" />
                  <span className="truncate">{o.label}</span>
                </label>
              ))}
              {!shown.length && <p className="text-xs text-slate-400 px-1.5 py-2">No matches</p>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
